// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__PPH6N","list":"styles_list__1DMHM"};